import { RestApiResponse } from '../common/rest-api.response';

import { Area } from './area';

export class AreaUpdateResponse extends RestApiResponse {
    public item: Area;

    constructor(data?: Partial<AreaUpdateResponse>) {
        super(data);
        this.item = data && data.item;
    }
}
